var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyLeadingPortalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "why-leading-portal-icon_svg__a",
    d: "M0 70h78.91V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 42c0 15.464-12.537 28-28 28-15.464 0-28-12.536-28-28s12.536-28 28-28c15.463 0 28 12.536 28 28",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.727 44.545H7.637V3.818a2.545 2.545 0 012.545-2.545h56a2.545 2.545 0 012.545 2.545v40.727z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.727 43.273l-1.273 1.272h-6.363l-1.273-1.272H1.272c0 2.811 2.28 5.09 5.091 5.09H50.91v-5.09H40.727z",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91 43.273H6.363V3.82A3.822 3.822 0 0110.182 0h56A3.822 3.822 0 0170 3.82V14h-2.545V3.82c0-.703-.572-1.273-1.273-1.273h-56c-.701 0-1.273.57-1.273 1.273v39.454z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.91 49.637H6.363A6.37 6.37 0 010 43.273V42h32.345l1.273 1.273h5.31L40.2 42h10.71v2.546h-9.656l-1.273 1.273h-7.417l-1.273-1.273H2.763a3.826 3.826 0 003.6 2.545H50.91v2.546z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09 16.545H56a2.545 2.545 0 00-2.546 2.546v40.727A2.546 2.546 0 0056 62.364h19.09a2.546 2.546 0 002.546-2.546V19.091a2.545 2.545 0 00-2.545-2.546",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 17.819c-.701 0-1.273.57-1.273 1.272V59.82c0 .702.572 1.272 1.273 1.272h19.09c.702 0 1.274-.57 1.274-1.272V19.09c0-.702-.572-1.272-1.273-1.272H56zm19.09 45.818H56a3.823 3.823 0 01-3.818-3.818V19.09A3.823 3.823 0 0156 15.273h19.09a3.823 3.823 0 013.82 3.818V59.82a3.823 3.823 0 01-3.82 3.818z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "why-leading-portal-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#why-leading-portal-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#why-leading-portal-icon_svg__b)",
    d: "M63.636 59.818h3.819v-2.545h-3.819z"
  }))));
}
export default SvgWhyLeadingPortalIcon;